import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowLeftCircle"><path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM6.79289 12L11 7.79289L11.7071 8.5L8.70711 11.5H17V12.5H8.70711L11.7071 15.5L11 16.2071L6.79289 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeftCircle;
